export const parseFloatReturnEmptyIfZero = (str?: string | null): number | string => {
  if (str === undefined || str === null) return '';
  if (str === '') return '';

  const parsed = parseFloat(str);

  return !parsed || parsed === 0 ? '' : parsed;
};
